import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import ReactApp from "./App.jsx";
import { LanguageProvider } from "./contexts/LanguageContext";
import { VoiceProvider } from "./contexts/VoiceContext";
import { WebARAppProvider } from "./contexts/WebARAppContext";

const updateRootDimensions = () => {
  const root = document.getElementById("root");
  if (root) {
    root.style.width = `${window.innerWidth}px`;
    root.style.height = `${window.innerHeight}px`;
  }
};

export async function bootstrapReact(webARApp) {
  // Update dimensions on initialization
  updateRootDimensions();

  // Add event listeners
  window.addEventListener("resize", updateRootDimensions);
  window.addEventListener("orientationchange", updateRootDimensions);

  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <LanguageProvider>
        <VoiceProvider>
          <WebARAppProvider appInstance={webARApp}>
            <ReactApp />
          </WebARAppProvider>
        </VoiceProvider>
      </LanguageProvider>
    </StrictMode>
  );
}
